import { date } from '@utils/util.js';

const config = {
  emoji (val) {
    let ranges = ['\ud83c[\udf00-\udfff]', '\ud83d[\udc00-\ude4f]', '\ud83d[\ude80-\udeff]'];
    return val.replace(new RegExp(ranges.join('|'), 'g'), '');
  },
  money (val, digit = 2) {
    if (!val) return;
    val = Number(val);
    return val ? val.toFixed(digit) : '0.00';
  },
  filternum (val) {
    if (!val) return '0.00';
    val += '';
    let num = '0.00';
    num = val >= 0 ? val : '0.00';
    num = val.indexOf('.') > -1 ? (val.substring(0, val.indexOf('.') + 3) * 1).toFixed(2) : val + '.00';
    return num;
  },
  videoValue (value) {
    return value.replace(/^.*(http.*\.mp4)$/, '$1');
  },
  formatTime (time) {
    return (time / 1000).toFixed();
  },
  phone (val) {
    return val.replace(/^(\d{3})(\d*)(\d{4})$/, '$1****$3');
  },
  card (val) {
    val += '';
    return val.replace(/^(\d{4})(\d*)(\d{4})$/, '$1*********$3');
  },
  name (val) {
    val = val.toString();
    return val.replace(/.(?=.)/g, '*');
  }
};

config.date = date;

const install = Vue => {
  for (let key in config) {
    Vue.filter(key, config[key]);
  }
};

export default {
  install
};



// WEBPACK FOOTER //
// ./src/filters/index.js